<div class="mijn-error canvas">
    <div class="mijn-error__container">
        <div class="mijn-error__illustration">
            @if (!animationName) {
                <ap-illustration name="error"></ap-illustration>
            } @else {
                <ap-animation [name]="animationName" [width]="'16rem'" [height]="'16rem'"> </ap-animation>
            }
        </div>
        <h1 class="tertiary">{{ title }}</h1>
        <ng-content></ng-content>
    </div>
</div>
